/**
 * @author: ritesh.dabral
 * 
 * This page imports all constants, and creates required function
 * 
 */

 import { 
    UPDATE_CLICKED_IMAGE_URL,
    UPDATE_IMAGE_FILE_DATA
   } from './HomePageActionType'


  export const updateImageURL = (imageURL,subCategoryId, index,sampleImagesForCurrCategory,pageName) => {
    return {
      type: UPDATE_CLICKED_IMAGE_URL,
      payload: {imageURL,subCategoryId, index,sampleImagesForCurrCategory,pageName},
      info: 'SpyneHome Component - updateImageURL'
    }
  }

  export const updateImageFileData = (file)=>{
    return {
      type: UPDATE_IMAGE_FILE_DATA,
      payload: file,
      info: 'SpyneHome Component - updateImageFileData'
    }
  }

 // exports
 const homePageActionControllers = {
    updateImageURL,
    updateImageFileData
 }
 
 export default homePageActionControllers;